module.exports = __webpack_public_path__ + "static/media/step-02.dce91e29.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/fiduciaria_flow_2/img/step-02.png
 ** module id = 1435
 ** module chunks = 0
 **/